import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apikeyService } from '../services/apikeyService';
import type { GenerateApiKeyPayload } from '../types/apikey.types';

export function useApiKeys() {
  return useQuery({
    queryKey: ['apikeys'],
    queryFn: () => apikeyService.getApiKeys(),
    staleTime: 0,
  });
}

export function useGenerateApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: GenerateApiKeyPayload) => apikeyService.generateApiKey(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apikeys'] });
    },
  });
}

export function useDeleteApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => apikeyService.deleteApiKey(id),
    onSuccess: (result) => {
      if (result.success) {
        queryClient.invalidateQueries({ queryKey: ['apikeys'] });
      }
    },
  });
}
